import { Injectable } from '@angular/core';
import { HttpClient,HttpResponse } from '@angular/common/http';
import { Observable,of } from 'rxjs';
import soinumapa from "../assets/geojson/soinumapa.json";
import { SlicePipe } from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class GeojsonService {

  constructor(private http: HttpClient,
    private slicePipe:SlicePipe) {
    let items = soinumapa.features as any[]
    // only gizartea (sociedad)
    this.items = items.filter( (i) => {
      if (i.properties) {
        let category = i.properties.category
        if (category==="Gizartea") { return true }
      }
      return false
    })
    this.total_pages
    let pages = Object.keys(this.items).length/this.per_page
    if (pages%1!=0) pages=Math.floor(pages)+1
    this.total_pages = pages
  }

  items:any[]
  per_page:number=10
  total_pages:number=0


  getTotalPages():number { return this.total_pages }

  getItems(feed:any):any {
    let page = feed.page
    let start:number = (page-1)*this.per_page
    let end:number = (page-1)*this.per_page+this.per_page
    let items:any[] = this.items

    if (feed.search) {
      items = this.items.filter( (i) => {
        if (i.properties) {
          let title = i.properties.title
          if (title.toLowerCase().search(feed.search.toLowerCase())>=0) return true
          return false
        } else { return false }
      })
    }
    // if (feed.search!='') items = items.filter( (i) => {i.title.search(feed.search)})
    return this.slicePipe.transform(items, start, end);
  }

  getCount():any {
    return Object.keys(this.items).length
  }
}
